import { defineStore } from 'pinia'

import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const usePermissionsStore = defineStore('permissions', {
  state,
  getters,
  actions,
})

export default usePermissionsStore
